/**
 * Custom Radio Component
 * Extends Ant Design Radio with custom styling
 */

import { Radio as AntRadio, RadioProps } from 'antd';
import classNames from 'classnames';
import './CustomRadio.scss';

export interface CustomRadioProps extends RadioProps {
  /** Radio variant */
  variant?: 'default' | 'button' | 'card';
}

/**
 * CustomRadio Component
 */
const CustomRadioComponent: React.FC<CustomRadioProps> = ({
  variant = 'default',
  className,
  ...rest
}) => {
  const radioClasses = classNames('custom-radio', `custom-radio--${variant}`, className);

  return <AntRadio {...rest} className={radioClasses} />;
};

/**
 * CustomRadioGroup Component
 */
export const CustomRadioGroup = AntRadio.Group;

/**
 * CustomRadioButton Component
 */
export const CustomRadioButton = AntRadio.Button;

// Attach Group and Button to CustomRadio for convenience
export const CustomRadio = Object.assign(CustomRadioComponent, {
  Group: AntRadio.Group,
  Button: AntRadio.Button,
});

export default CustomRadio;

